export const UPLOAD_FILE_TYPE =
    'image/xbm,image/tiff,image/apng,image/jpg,image/jpeg,image/ico,image/jfif,image/webp,image/png,image/bmp,image/gif';
export const TASK_POLLING_INTERVAL = 1 * 1000; //任务轮询时间
export const MAX_COMPRESS_IMAGE_SIZE = 2000;
export const MAX_POLLING_ERROR_TIME = 5;
export const UPLOAD_FILE_TYPE_NO_GIF =
    'image/xbm,image/tiff,image/apng,image/jpg,image/jpeg,image/ico,image/jfif,image/webp,image/png,image/bmp';
export const UPLOAD_FILE_TYPE_IMAGE_EXTENDER = '.jfif,.jpg,.webp,.jpeg,.png,.tiff,.bmp';

export const UPLOAD_FILE_TO_VIDEO = 'image/png,image/jpg,image/jpeg,image/jfif,image/webp,image/bmp, image/tiff';

export const UPLOAD_FILE_TYPE_OF_AUDIO = 'audio/mpeg,audio/wav';
export const TEXT_TO_VIDEO_POLLING_INTERVAL = 2 * 1000; //任务轮询时间

export const UPLOAD_FILE_TYPE_VIDEO = 'video/mp4,video/avi,video/mkv';
export const UPLOAD_FILE_TYPE_PPT = '.pptx,.ppt,.pdf';
export const UPLOAD_FILE_TYPE_PRODUCE_IMAGE =
    'image/xbm,image/apng,image/jpg,image/jpeg,image/ico,image/jfif,image/webp,image/png,image/bmp';
